import withBugsnag, { BugsnagNotify } from './Bugsnag'
export { BugsnagNotify }
export default withBugsnag
